<template>
  <div class="briefs-dashboard">
    <div class="briefs-dashboard-left-container">
      <div class="briefs-dashboard-heading">Hi {{ user.first_name }}, manage your briefs here</div>
      <div class="findspace-nav-container">
        <div class="tabbed-nav-container">
          <div class="tabbed-nav" :class="{active: activeNav == 'active'}" @click="activeNav = 'active'">Active</div>
          <div class="tabbed-nav" :class="{active: activeNav == 'archive'}" @click="activeNav = 'archive'" v-if="archivedBriefs.length">Archive</div>
        </div>
        <div class="briefs-nav">
          <div class="button primary create-new-brief-btn-gtm" @click="goToCreateBrief">Create Brief</div>
        </div>
      </div>
      <div class="brief-list" v-if="briefs.length">
        <div class="brief-heading-container tablet-hidden">
          <div class="brief-heading-label">Brief Name</div>
          <div class="brief-heading-label">Type</div>
          <div class="brief-heading-label">Dates</div>
          <div class="brief-heading-label"></div>
        </div>

        <div class="brief-block" v-for="brief in briefs" :key="'brief-' + brief.id">
          <div class="brief-name-container">
            <div class="brief-created-date">{{ brief.created_at ? new Date(brief.created_at).toLocaleDateString() : '' }}</div>
            <div class="brief-title-label">{{ brief.campaign_title }}</div>
          </div>
          <div class="brief-status-mobile tablet-only">
            <div class="brief-status" :class="[slugifyString(brief.status)]">
              {{ brief.status }}
            </div>
          </div>
          <div class="brief-type-label">
            {{ brief.availability_type }}
            <div class="brief-date-label tablet-only">
              {{ brief.production_start_date ? new Date(brief.production_start_date).toLocaleDateString('en-au', {day: '2-digit', month: '2-digit',year: '2-digit'}) : '' }}
              <span class="arrow tablet-hidden">
                <svg xmlns="http://www.w3.org/2000/svg">
                  <image xlink:href="/images/icons/arrow-right.svg" />
                </svg>
              </span>
              {{ brief.production_end_date ? new Date(brief.production_end_date).toLocaleDateString('en-au', {day: '2-digit', month: '2-digit',year: '2-digit'}) : '' }}
            </div>
          </div>
          <div class="brief-date-status-container tablet-hidden">
            <div class="brief-date-label">
              {{ brief.production_start_date ? new Date(brief.production_start_date).toLocaleDateString('en-au', {day: '2-digit', month: '2-digit',year: '2-digit'}) : '' }}
              <span class="arrow tablet-hidden">
                <svg xmlns="http://www.w3.org/2000/svg">
                  <image xlink:href="/images/icons/arrow-right.svg" />
                </svg>
              </span>
              {{ brief.production_end_date ? new Date(brief.production_end_date).toLocaleDateString('en-au', {day: '2-digit', month: '2-digit',year: '2-digit'}) : '' }}
            </div>
            <div class="brief-status" :class="[slugifyString(brief.status)]">
              {{ brief.status }}
            </div>
          </div>
          <div class="brief-buttons">
            <div class="share-button" v-if="activeNav == 'active'" @click="openShareModal(brief)">
              <svg xmlns="http://www.w3.org/2000/svg">
                <image xlink:href="/images/icons/export.svg" />
              </svg>
            </div>
            <div
              class="archive-button"
              v-if="activeNav == 'active'"
              @click="archiveBrief(brief)"
              v-floating-tooltip="'You can archive a shortlist that is no longer in use. Archived briefs can be restored at any time from the archive tab'"
            >
              <svg xmlns="http://www.w3.org/2000/svg">
                <image xlink:href="/images/icons/trash-2.svg" />
              </svg>
            </div>
            <div class="archive-button" v-if="activeNav == 'archive'" @click="unarchiveBrief(brief)">
              <svg xmlns="http://www.w3.org/2000/svg">
                <image xlink:href="/images/icons/restore.svg" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination mt-8" v-if="briefs.length">
        <pagination
          :current-page="page"
          :total-pages="totalPages"
          @change-page="changePage"
        ></pagination>
      </div>
      <!-- No briefs block -->
      <div class="no-brief-container" v-else>
        <div class="no-briefs-container">
          <div class="no-briefs-icon">
            <svg xmlns="http://www.w3.org/2000/svg">
              <image xlink:href="/images/icons/archive-book.svg" />
            </svg>
          </div>
          <div class="no-briefs-heading">
            You have no briefs
          </div>
          <div class="no-briefs-text">
            Create one now and get started
          </div>
          <div class="no-briefs-btn button primary" @click="goToCreateBrief">
            Create a brief
          </div>
        </div>
      </div>
    </div>
    <div class="briefs-dashboard-right-container">
      <div class="lets-chat-block tablet-hidden">
        <div class="question-block">
          <svg xmlns="http://www.w3.org/2000/svg">
            <image xlink:href="/images/icons/message-question.svg" />
          </svg>
        </div>
        <div class="lets-chat-heading">Need help?</div>
        <div class="lets-chat-text">Click chat below to connect directly with our sales team, or need some inspo click here to check out our <a href="#" @click="viewLookbooks">APS Shortlists</a></div>
        <div class="lets-chat-btn-container">
          <button class="button lets-chat-btn-transparent" @click="openChat">Let's Chat</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import kebabCase from 'lodash/kebabCase';

export default {
  data() {
    return {
      activeNav: 'active',
      page: 1,
    }
  },
  methods: {
    slugifyString(val) {
      return kebabCase(val);
    },
    openChat() {
      this.$store.dispatch("intercom/openNewChat");
    },
    viewLookbooks() {
      this.$store.commit('findspace/navigateToSubpage', { page: 'shortlists', subpage: 'lookbooks' })
    },
    goToCreateBrief() {
      this.$store.commit('findspace/setSubpage', { subpage: 'create' })
    },
    archiveBrief (brief) {
      this.$store.dispatch('modals/show', {
        title: 'Archive brief?',
        cancelLabel: 'Cancel',
        confirmLabel: 'Archive brief',
        confirmMessage: `Are you sure you want to archive the brief <b class="wt-bold">${brief.campaign_title}</b>?`,
        data: brief,
        narrow: true
      })
      .then(() => {
        axios.delete(`/api/account/briefs/${brief.id}`)
          .then(() => {
            this.$store.commit('user/archiveBrief', brief.id)
            this.$toasted.show(`Your brief "${brief.campaign_title}" has been archived.`, {
              type: 'success'
            })
          })
          .catch(() => {
            this.$toasted.show('Your brief could not be archived, please try again.', {
              type: 'error'
            })
          })
          .then(() => {})
      })
      .catch(() => {})
    },
    unarchiveBrief (brief) {
      this.$store.dispatch('modals/show', {
        title: 'Restore brief?',
        cancelLabel: 'Cancel',
        confirmLabel: 'Restore brief',
        confirmMessage: `Are you sure you want to restore the brief <b class="wt-bold">${brief.campaign_title}</b>?`,
        data: brief,
        narrow: true
      })
      .then(() => {
        axios.post(`/api/account/briefs/${brief.id}/unarchive`)
          .then(() => {
            this.$store.commit('user/restoreBrief', brief.id)
            this.$toasted.show(`Your brief "${brief.campaign_title}" has been restored.`, {
              type: 'success'
            })
            if (!this.archivedBriefs.length) {
              this.activeNav = 'active'
            }
          })
          .catch(() => {
            this.$toasted.show('Your brief could not be restored, please try again.', {
              type: 'error'
            })
          })
          .then(() => {})
      })
      .catch(() => {})
    },
    changePage(which) {
      this.page = which;
    },
    openShareModal(brief) {
      this.$store
        .dispatch("modals/show", {
          type: "brief-share",
          maskCanDismiss: false,
          headless: true,
          narrow: true,
          data: {
            brief: brief
          }
        });
    },
  },
  computed: {
    user () {
      return this.$store.getters['user/account']
    },
    archivedBriefs() {
      return this.$store.getters["user/archivedBriefs"].sort((a, b) => (a.campaign_title > b.campaign_title) ? 1 : ((b.campaign_title > a.campaign_title) ? -1 : 0));
    },
    briefs() {
      let briefs = [];
      if (this.activeNav == 'active') {
        briefs = this.$store.getters["user/briefs"].sort((a, b) => (a.campaign_title > b.campaign_title) ? 1 : ((b.campaign_title > a.campaign_title) ? -1 : 0));
      } else {
        briefs = this.archivedBriefs;
      }
      return briefs.slice((this.page - 1) * 6, this.page * 6);
    },
    totalPages() {
      let briefs = [];
      if (this.activeNav == 'active') {
        briefs = this.$store.getters["user/briefs"];
      } else {
        briefs = this.archivedBriefs;
      }
      return Math.ceil(briefs.length / 6);
    }
  }
}
</script>
